import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const [authStatus, setAuthStatus] = useState('checking'); // 'checking', 'authenticated', 'unauthenticated'

    useEffect(() => {
        const token = sessionStorage.getItem("token");
        setAuthStatus(token ? 'authenticated' : 'unauthenticated');
    }, []);

    if (authStatus === 'checking') {
        return null; // or a loading spinner
    }

    if (authStatus === 'unauthenticated') {
        return <Navigate to="/" replace />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;